import defaultSettings from '../defaultSettings';

export default {
  namespace: 'setting',
  state: defaultSettings,
};
